import { createElement as _createElement } from "react";
import { forwardRef } from 'react';
import { BKJListItem } from '../../BKJListItem/index.js';
import { useBKJComboBoxAsyncContext } from './BKJComboBoxAsync.context.js';
export const BKJComboBoxAsyncItem = forwardRef((props, ref) => {
    const { value, index, label, style, disabled, type } = props;
    const { getItemProps, selectedItem, highlightedIndex, name } = useBKJComboBoxAsyncContext();
    const itemProps = getItemProps({
        item: props,
        isSelected: selectedItem?.value === value,
        index,
        value,
        label,
        checked: selectedItem?.value === value,
        disabled,
        style,
        name,
        ref,
    });
    return (_createElement(BKJListItem, { variant: "SpaceBetween", isTargeted: highlightedIndex === index, ...itemProps, selected: [selectedItem?.value], ref: ref, key: `${value}`, subLabel: props?.subLabel, type: type }));
});
//# sourceMappingURL=BKJComboBoxAsyncItem.js.map